function TextContent({ text }: { text: string }) {
  const urlPattern = /(https?:\/\/[^\s]+)/g;

  const parts = text.split(urlPattern);

  return (
    <p className="whitespace-pre-wrap break-words text-base mb-2">
      {parts.map((part, index) => {
        if (urlPattern.test(part)) {
          return (
            <a
              key={index}
              target="_blank"
              rel="noopener noreferrer"
              href={part}
              className="text-blue-500 hover:underline"
            >
              {part}
            </a>
          );
        }
        return <span key={index}>{part}</span>;
      })}
    </p>
  );
}

export { TextContent };
